import {getEntraStats, getEntraIdDashboardStats} from "@/services/api/app/office/stats";
import {ENTRA_TYPE_MAP} from "@/store/app/office/entraTypeMap";

const defaultState = () => ({
  entraStats: {},
  dashboardStats: null,
});

export default {
  namespaced: true,

  actions: {
    getEntraStats({commit}, data) {
      return getEntraStats(data)
        .then(stats => {
          commit('setEntraStats', stats);
          return stats;
        })
    },
    getEntraIdDashboardStats({commit}, data) {
      return getEntraIdDashboardStats(data)
        .then(stats => {
          commit('setDashboardStats', stats);
          return stats;
        })
    },
    getStats({dispatch}, data) {
      return dispatch('getEntraStats', data);
    },
  },

  mutations: {
    setEntraStats(state, stats) {
      state.entraStats = stats;
    },
    setDashboardStats(state, stats) {
      state.dashboardStats = stats;
    },
  },

  getters: {
    isEntraIdConnectedAsProvider: (state) => {
      return !!state.dashboardStats;
    },
    getDashboardStats: (state) => {
      const processedStats = {
        ...state.entraStats,
        entraObjectStats: state.entraStats?.entraObjectStats || [],
      };

      state.entraStats?.entraObjectStats?.forEach(item => {
        const key = ENTRA_TYPE_MAP[item.objectType];

        if (key) {
          processedStats[key] = {
            ...item,
            lastBackups: item.lastBackups,
            totalObjects: item.total,
            activeUsers: item.total
          };
        }
      });

      return processedStats;
    },
  },

  state: defaultState(),
}
